import type { BetterstartPresetDefinition } from '@preset-engine/types.js'

export const blogPreset: BetterstartPresetDefinition = {
  id: 'blog',
  title: 'Blog',
  description: 'Posts content module',
  kind: 'content',
  version: '1.0.0',
  dependencies: [],
  conflicts: [],
  schemaFiles: ['posts.json', 'menus.json'],
  files: [],
  packageDependencies: ['katex', 'markdown-it@^13.0.2', 'markdown-it-dollarmath', 'sanitize-html'],
  devDependencies: ['@types/markdown-it@13', '@types/sanitize-html'],
  envSections: [],
  configure: 'none'
}
